import Loadable from '../../components/loadable';

const EditWorkout = Loadable({
  loader: () => import('../../pages/workouts/edit_workout'),
  type: 'block',
});

angular.module('gym').value('EditWorkout', EditWorkout);
